import { ParameterType } from '@/study-search/enums';

import { DegreeTypeFilterOptionValue } from '@studyportals/search-filters';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';

class PhdDegreeTypeFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DEGREE_TYPE,
			[
				new FilterOptionInformation('Ph.D', DegreeTypeFilterOptionValue.PHD, 'ph-d', 'Ph.D', 'Ph.D', 'Ph.Ds'),
				new FilterOptionInformation('D.B.A', DegreeTypeFilterOptionValue.DBA, 'dba', 'D.B.A', 'D.B.A', 'D.B.As'),
				new FilterOptionInformation(
					'Doctorate',
					DegreeTypeFilterOptionValue.DOCTORATE,
					'doctorate',
					'Doctorate',
					'Doctorate',
					'Doctorates'
				)
			],
			[DegreeTypeFilterOptionValue.PHD, DegreeTypeFilterOptionValue.DBA, DegreeTypeFilterOptionValue.DOCTORATE]
		);
	}
}

export default new PhdDegreeTypeFilterDefinition();
